module.exports = __webpack_public_path__ + "img/team-photo.dc864a0d.png";